export const SCRUM_TEAM = 'Scrum' as const;
export const KANBAN_TEAM = 'Kanban' as const;

export const SINGLE_CUSTOM_FIELD_TYPE_KEY =
	'com.atlassian.jira.plugin.system.customfieldtypes:select';
export const MULTI_CUSTOM_FIELD_TYPE_KEY =
	'com.atlassian.jira.plugin.system.customfieldtypes:multiselect';

export const SYSTEM_LABEL_FIELD_ID = 'labels';

export const CUSTOM_FIELD_OPTION_MISSED_ERROR = 'CUSTOM_FIELD_OPTION_MISSED';

export const FILTER_FIELD_ERROR = {
	NOT_FOUND: 'CUSTOM_FIELD_NOT_FOUND', // Custom field is permanently deleted that you cannot restore.
	TRASHED: 'CUSTOM_FIELD_TRASHED', // Custom field is in trash and would be deleted in 2 months after it's trashed. Admin could restore it.
	NOT_IN_PLAN: 'CUSTOM_FIELD_NOT_IN_PLAN', // Custom field is not found in plan settings.
	OPTION_NOT_FOUND: 'CUSTOM_FIELD_OPTION_NOT_FOUND', // Custom field option is either renamed or deleted in the admin page.
} as const;

export const MAX_ACTIVE_BOARDS = 2;

export const IP_BOARD_STORY_POINTS_PLANNING_UNIT = 'StoryPoints' as const;
export const IP_BOARD_HOURS_PLANNING_UNIT = 'Hours' as const;
export const IP_BOARD_DAYS_PLANNING_UNIT = 'Days' as const;

// Lowercase the team name in teams.json to follow jira/build-tools/eslint-plugin-jira/rules/js/team-name-enforcer-for-error-analytics/index.js
export const ERROR_REPORTING_TEAM = 'axolotl';
export const PACKAGE_NAME = 'jiraPortfolio3PlanIncrementCommon';

export const DOC_LINKS = {
	PROGRAM_BOARD:
		'https://support.atlassian.com/jira-software-cloud/docs/what-is-the-program-board-in-my-plan/',
	LINK_SPRINTS:
		'https://support.atlassian.com/jira-software-cloud/docs/add-and-change-sprints-on-the-program-board-in-your-plan/',
	CREATION:
		'https://support.atlassian.com/jira-software-cloud/docs/what-does-the-program-board-show/',
};

export const IPH_IDS = {
	PROGRAM_BOARDS_CREATE: '6gJCMknYvLjnUgKrm4BKIj',
	PROGRAM_BOARDS_SETTINGS: '1pdnvDJUBHtLdAcH6F03rm',
};

export const MARK_SYNC_SPRINTS_PREFIX = 'plan-increment.sync-sprints:';
export const MARK_SYNC_SPRINTS_START = `${MARK_SYNC_SPRINTS_PREFIX}start`;
export const MARK_SYNC_SPRINTS_END = `${MARK_SYNC_SPRINTS_PREFIX}end`;
